import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'
import { assert } from '../../../lib/assert-sidecar'
import { chessGameManager } from '../chessGameManager-sidecar'
import { EChessTeam } from '../chessPieces'
import { chessUiMultiplayerCursors } from '../ui/chessUiMultiplayerCursors-sidecar'
import { EChessClientRequest } from './chessMessageClientRequest'
import { EChessMessage } from './chessMessageIds'
import { chessWebsockets } from './chessWebsockets-sidecar'

export interface IChessMessageClientRequestResponse {
  multiId: number
  command: EChessClientRequest
}

export const messageId = EChessMessage.ClientRequestResponse

export function write(
  m: IMessageWriter,
  d: IChessMessageClientRequestResponse,
) {
  messageWriter.write8(m, messageId)
  messageWriter.write16(m, d.multiId)
  messageWriter.write8(m, d.command)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, messageId)

  let d: IChessMessageClientRequestResponse = {
    multiId: messageWriter.read16(m),
    command: messageWriter.read8(m),
  }
  return d
}

export function test() {
  let ex: IChessMessageClientRequestResponse = {
    multiId: 12345,
    command: EChessClientRequest.Spectate,
  }
  messageWriter.test('client-request-response', ex, write, read)
}

export function process(m: IMessageWriter, isFromHost: boolean) {
  let msg = read(m)
  if (websockets.testRequiredFromHost(isFromHost, m, messageId)) {
    return
  }

  let isUs = msg.multiId === chessWebsockets.getMultiId()

  const sit = (t: EChessTeam) => {
    if (isUs) {
      chessGameManager.get().team = t
    } else {
      if (chessGameManager.get().team === t) {
        chessGameManager.get().team = EChessTeam.Spectator
      }
    }
    chessUiMultiplayerCursors.networkRecieveTeam(msg)
  }

  if (msg.command === EChessClientRequest.SitWhite) {
    sit(EChessTeam.White)
  }
  if (msg.command === EChessClientRequest.SitBlack) {
    sit(EChessTeam.Black)
  }
  if (msg.command === EChessClientRequest.Spectate) {
    sit(EChessTeam.Spectator)
  }
}

export function sendMessageAndImmediatelyExecute(
  msg: IChessMessageClientRequestResponse,
) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}

export function sendMessageWorldState(
  msg: IChessMessageClientRequestResponse,
  multiId: number,
) {
  websockets._sendMessageWorldState(write, msg, multiId)
}
